import * as React from 'react';

export const PauseIcon = ({ width = 44, height = 48, fill = "#1E1E1E", ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M44 4V44C44 45.0609 43.5786 46.0783 42.8284 46.8284C42.0783 47.5786 41.0609 48 40 48H30C28.9391 48 27.9217 47.5786 27.1716 46.8284C26.4214 46.0783 26 45.0609 26 44V4C26 2.93913 26.4214 1.92172 27.1716 1.17157C27.9217 0.421427 28.9391 0 30 0H40C41.0609 0 42.0783 0.421427 42.8284 1.17157C43.5786 1.92172 44 2.93913 44 4ZM14 0H4C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4V44C0 45.0609 0.421427 46.0783 1.17157 46.8284C1.92172 47.5786 2.93913 48 4 48H14C15.0609 48 16.0783 47.5786 16.8284 46.8284C17.5786 46.0783 18 45.0609 18 44V4C18 2.93913 17.5786 1.92172 16.8284 1.17157C16.0783 0.421427 15.0609 0 14 0Z"
        fill={fill}/>
    </svg>
  );
};
